import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API2_SHCONTACTS} from 'consts/api2'



import * as $utils from 'utils';
export class ShContact extends BaseStore {
  constructor(values = {}) {
    super({
      id: crypto.randomUUID(),
      first_name: undefined,
      last_name: undefined,
      middle_name: undefined,
      linkedin_id: undefined,
      position: undefined,
      shared_company_id: undefined,
      avatar_url: undefined,
      followers_cnt: undefined,
      ...values
    })
  }

  get name(){
    return `${this._state.first_name} ${this._state.last_name}`
  }
  async uploadAvatar(file) {
    file.filename = this.id

    const formData = new FormData()
    formData.append('contact_id', this.id)
    formData.append('file', file)

    const {avatar_url} = await this._rest.put(`${API2_SHCONTACTS}/avatar`, formData, {force_form_data: true})
    this._state.avatar_url = null
    await $utils.timers.wait(5000) // allow cloudfront cache to be invalidated
    this._state.avatar_url = avatar_url
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    const {bleach} = await rest.patch(`${API2_SHCONTACTS}/${this.id}`, to_write)
    this._bleach(bleach)
  }
}


export class ShContacts extends BaseStore {
  constructor() {
    super({
      view_items: [],
      view_total: 0,
      total: 0,
    })
  }

  getContact(id) {
    return this._state.view_items.find(x => x.id === id)
  }

  async newContact(data) {
    const {bleach} = await this._rest.post(API2_SHCONTACTS, data)
    return new ShContact(bleach)
  }

  async doLoad(rest, params) {
    const result = await (rest || this._rest).get(API2_SHCONTACTS, params)
    this._state.view_items = result.view_items.map(data => new ShContact(data))
    this._state.view_total = result.view_total
    this._state.total = result.total
  }
}


const contacts = StoreProxy(new ShContacts(), {array_prop: 'view_items'})
export default contacts
